import Link from "next/link";
import { useTranslations } from "next-intl";

import appRoutes from "~/utils/app-routes";

import styles from "./customer-care.module.scss";

export default function CustomerCare() {
  const t = useTranslations();
  return (
    <div className={styles.container}>
      {t.rich("generic.customer_care", {
        gradient: (chunks) => {
          return <span className={styles.gradient}>{chunks?.toString()}</span>;
        },
        link: (chunks) => {
          return (
            <Link href={appRoutes.CUSTOMER_HELP_CENTER} className={styles.link}>
              {chunks?.toString()}
            </Link>
          );
        },
      })}
    </div>
  );
}
